import React from 'react';
import { useIsFeatureEnabled } from '@innovyze/stylovyze/lib/utils/features';
import AboutToExpire from './AboutToExpire';
import { STYLOVYZE_FLAGS } from '@innovyze/stylovyze/lib/types/features';
export default function AboutToExpireFeature({ hasSharedWorkers, }) {
    const hasAboutToExpire = useIsFeatureEnabled(STYLOVYZE_FLAGS.ABOUT_TO_EXPIRE);
    if (!hasAboutToExpire)
        return React.createElement(React.Fragment, null);
    return React.createElement(AboutToExpire, { hasSharedWorkers: hasSharedWorkers });
}
